import { Pipe, PipeTransform } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { App_FormBloc, App_FormStep } from 'src/app/utils/interfaces';

@Pipe({
  name: 'getFieldInFormPipe'
})
export class GetFieldInFormPipe implements PipeTransform {

  transform(form: FormGroup, step: App_FormStep, bloc: App_FormBloc, fieldOrLabel: any): FormControl | null {
    const stepformGroup = form.controls[step.name];
    if (stepformGroup instanceof FormGroup) {
      const blocFormGroup = stepformGroup.controls[bloc.name]
      if (blocFormGroup instanceof FormGroup) {
        const fieldControl = blocFormGroup.controls[fieldOrLabel.name]
        return fieldControl instanceof FormControl
        ? fieldControl
        : null
      }
    }
    return null;
  }

}
